import { Module } from 'vuex';
import { RootState, RootGettersReturns } from '../types/index';
import {
  JitsiGettersKeys,
  JitsiMutationsKeys,
  JitsiMutationsPayload,
  JitsiActionsKeys,
  JitsiState,
} from '../types/jitsi';
import {
  SocketActionsKeys,
  StartConferenceEmit,
  StopConferenceEmit,
  JoinConferenceEmit,
  LeaveConferenceEmit,
  StartExternalConferenceEmit,
} from '../types/socket';

const initState = () => {
  const state: JitsiState = {
    ongoing: false,
    joined: false,
    left: false,
    invitedToExternalConference: false,
  };
  return state;
};
const Jitsi: Module<JitsiState, RootState> = {
  state: {
    ...initState(),
  },
  actions: {
    [JitsiActionsKeys.START_MEET]: async ({ dispatch, commit, rootGetters }) => {
      const pin = (rootGetters as RootGettersReturns).sessionPin;
      if (!pin) return;
      const params: StartConferenceEmit = {
        type: 'start_conference',
        params: [{ pin }],
      };
      await dispatch(SocketActionsKeys.SOCKET_EMIT, params);
      commit(JitsiMutationsKeys.CREATE_MEET);
    },
    [JitsiActionsKeys.STOP_MEET]: async ({ dispatch, commit, rootGetters }) => {
      const pin = (rootGetters as RootGettersReturns).sessionPin;
      if (!pin) return;
      const params: StopConferenceEmit = {
        type: 'stop_conference',
        params: [{ pin }],
      };
      await dispatch(SocketActionsKeys.SOCKET_EMIT, params);
      commit(JitsiMutationsKeys.STOP_MEET);
    },
    [JitsiActionsKeys.JOIN_MEET]: async ({ dispatch, commit, rootGetters }) => {
      const pin = (rootGetters as RootGettersReturns).sessionPin;
      if (!pin) return;
      const params: JoinConferenceEmit = {
        type: 'join_conference',
        params: [{ pin }],
      };
      await dispatch(SocketActionsKeys.SOCKET_EMIT, params);
      commit(JitsiMutationsKeys.JOIN_MEET);
    },
    [JitsiActionsKeys.LEAVE_MEET]: async ({ dispatch, commit, rootGetters }) => {
      const pin = (rootGetters as RootGettersReturns).sessionPin;
      if (!pin) return;
      const params: LeaveConferenceEmit = {
        type: 'leave_conference',
        params: [{ pin }],
      };
      await dispatch(SocketActionsKeys.SOCKET_EMIT, params);
      commit(JitsiMutationsKeys.LEAVE_MEET);
    },
    [JitsiActionsKeys.START_EXTERNAL_MEET]: async ({ dispatch, rootGetters }) => {
      const pin = (rootGetters as RootGettersReturns).sessionPin;
      if (!pin) return;
      const params: StartExternalConferenceEmit = {
        type: 'start_ext_conference',
        params: [{ pin }],
      };
      await dispatch(SocketActionsKeys.SOCKET_EMIT, params);
    },
    [JitsiActionsKeys.SOCKET_ON_STARTED_CONFERENCE]: ({ commit }) =>
      // payload: JitsiActionsPayload['SOCKET_ON_STARTED_CONFERENCE']
      {
        commit(JitsiMutationsKeys.SET_ONGOING_MEET, true);
      },
    [JitsiActionsKeys.SOCKET_ON_STARTED_EXT_CONFERENCE]: ({ commit }) =>
      // payload: JitsiActionsPayload['SOCKET_ON_STARTED_CONFERENCE']
      {
        commit(JitsiMutationsKeys.SET_INVITED_TO_EXTERNAL_MEET, true);
      },
    [JitsiActionsKeys.SOCKET_ON_STOPPED_CONFERENCE]: ({ commit }) =>
      // payload: JitsiActionsPayload['SOCKET_ON_STOPPED_CONFERENCE']
      {
        commit(JitsiMutationsKeys.SET_ONGOING_MEET, false);
        commit(JitsiMutationsKeys.LEAVE_MEET);
      },
    [JitsiActionsKeys.RESET_STATE]: ({ commit }) => {
      commit(JitsiMutationsKeys.JITSI_RESET_STATE);
    },
  },
  mutations: {
    [JitsiMutationsKeys.CREATE_MEET]: state => {
      state.ongoing = true;
      state.joined = true;
      state.left = false;
    },
    [JitsiMutationsKeys.STOP_MEET]: state => {
      state.ongoing = false;
      state.joined = false;
      state.left = true;
    },
    [JitsiMutationsKeys.SET_ONGOING_MEET]: (state, ongoing: JitsiMutationsPayload['SET_ONGOING_MEET']) => {
      state.ongoing = ongoing;
      if (!ongoing) state.joined = false;
    },
    [JitsiMutationsKeys.JOIN_MEET]: state => {
      state.joined = true;
      state.left = false;
    },
    [JitsiMutationsKeys.LEAVE_MEET]: state => {
      state.joined = false;
      state.left = true;
    },
    [JitsiMutationsKeys.SET_INVITED_TO_EXTERNAL_MEET]: (
      state,
      payload: JitsiMutationsPayload['SET_INVITED_TO_EXTERNAL_MEET']
    ) => {
      state.invitedToExternalConference = payload;
    },
    [JitsiMutationsKeys.JITSI_RESET_STATE]: state => {
      Object.assign(state, initState());
    },
  },
  getters: {
    [JitsiGettersKeys.isMeetOngoing]: state => state.ongoing,
    [JitsiGettersKeys.isMeetJoined]: state => state.joined,
    [JitsiGettersKeys.isMeetLeft]: state => state.left,
    [JitsiGettersKeys.isInvitedToExternalConference]: state => state.invitedToExternalConference,
  },
};

export default Jitsi;
